import React from 'react';
import { ChefHat, Truck } from 'lucide-react';
import '../EarnMoneySection/EarnMoneySection.css';

interface EarnMoneySectionProps {
  onSellFood: () => void;
  onDeliveryPartner: () => void;
  showSellFood?: boolean;
  showDelivery?: boolean;
}

const EarnMoneySection: React.FC<EarnMoneySectionProps> = ({
  onSellFood,
  onDeliveryPartner,
  showSellFood = true,
  showDelivery = true,
}) => {
  return (
    <section className="earn-money-section">
      <div className="earn-money-container">
        <div className="section-header">
          <h2 className="section-title">Earn Money with HomeCookt</h2>
          <p className="section-subtitle">
            Turn your passion into profit. Join thousands earning extra income through food and delivery.
          </p>
        </div>

        <div className="opportunities-grid">
          {showSellFood && (
            <div className="opportunity-card cook-card">
              <div className="card-header">
                <div className="icon-wrapper cook-icon">
                  <ChefHat size={32} />
                </div>
                <div className="card-title-section">
                  <h3>Sell Your Food</h3>
                  <p>Cook. Share. Earn.</p>
                </div>
              </div>

              <div className="card-content">
                <div className="benefits-list">
                  <div className="benefit-item">
                    <span>🍽</span>
                    <span>Make food for others</span>
                  </div>
                  <div className="benefit-item">
                    <span>🕒</span>
                    <span>Cook any time</span>
                  </div>
                  <div className="benefit-item">
                    <span>🌟</span>
                    <span>People rate your meals</span>
                  </div>
                  <div className="benefit-item">
                    <span>📈</span>
                    <span>Earn more each week</span>
                  </div>
                </div>

                <button onClick={onSellFood} className="cta-button cook-button">
                  <span>🧑‍🍳</span>
                  Start Cooking
                </button>
              </div>
            </div>
          )}

          {showDelivery && (
            <div className="opportunity-card delivery-card">
              <div className="card-header">
                <div className="icon-wrapper delivery-icon">
                  <Truck size={32} />
                </div>
                <div className="card-title-section">
                  <h3>Become a Delivery Partner</h3>
                  <p>Pick up. Drop off. Earn.</p>
                </div>
              </div>

              <div className="card-content">
                <div className="benefits-list">
                  <div className="benefit-item">
                    <span>📦</span>
                    <span>Bring food to people</span>
                  </div>
                  <div className="benefit-item">
                    <span>🕒</span>
                    <span>Drive any time</span>
                  </div>
                  <div className="benefit-item">
                    <span>🔥</span>
                    <span>Extra pay when busy</span>
                  </div>
                  <div className="benefit-item">
                    <span>📈</span>
                    <span>Earn more each week</span>
                  </div>
                </div>

                <button onClick={onDeliveryPartner} className="cta-button delivery-button">
                  <span>🚴</span>
                  Start Delivering
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="bottom-cta1">
          <div className="cta-content1">
            <h3>Ready to Start Earning?</h3>
            <p>Join our community of food entrepreneurs and delivery partners making money doing what they love.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EarnMoneySection;
